import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style, styleVariants } from '@vanilla-extract/css';

export const percentageLabelVariants = styleVariants({
  low: {
    background: themeVars.badge.critical.background.idle,
    color: themeVars.badge.foreground.critical,
  },
  medium: {
    background: themeVars.badge.neutral.background.idle,
    color: themeVars.badge.foreground.default,
  },
  high: {
    background: themeVars.badge.success.background.idle,
    color: themeVars.badge.foreground.success,
  },
});

export const percentageLabel = style([
  typography['labelSm'],
  {
    outline: `1px solid ${themeVars.container.border.default}`,
    outlineOffset: '-1px',
    borderRadius: borderRadius.r8,
    padding: `${space.s4}px ${space.s8}px`,
  },
]);
